<div class="ai-assist-pro-container">
  <aside class="ai-assist-sidebar">
    <img src="assets/icons/app-icon-1.png" alt="LTTS Logo" class="ai-sidebar-logo" />
    <div class="ai-sidebar-title">AI Assistance</div>
    <div class="ai-sidebar-desc">How can I help you today?</div>
  </aside>
  <section class="ai-assist-main">
    <header class="ai-assist-header">
      <div class="ai-assist-header-left">
        <img src="assets/icons/app-icon-1.png" alt="Assistant" class="ai-assist-avatar" />
        <div>
          <div class="ai-assist-name">LTTS Genie</div>
          <div class="ai-assist-role">AI Assistant</div>
        </div>
      </div>
      <div class="ai-assist-header-right">
        <span class="ai-assist-user">{{user.name}}</span>
        <img [src]="user.avatar" alt="User" class="ai-assist-user-avatar" />
      </div>
    </header>
    <main class="ai-assist-chat-area">
      <div *ngFor="let msg of messages" class="ai-assist-msg-row" [ngClass]="{'ai-assist-msg-bot': msg.from === 'bot', 'ai-assist-msg-user': msg.from === 'user'}">
        <div class="ai-assist-msg-bubble">
          <span [innerHTML]="msg.text"></span>
          <div *ngIf="msg.tags && msg.tags.length" class="ai-assist-tags">
            <button *ngFor="let tag of msg.tags" class="ai-assist-tag">{{tag}}</button>
          </div>
        </div>
      </div>
    </main>
    <footer class="ai-assist-footer">
      <div class="ai-assist-footer-inner">
        <select class="ai-assist-footer-select">
          <option>Attendance</option>
          <option>Department</option>
        </select>
        <input class="ai-assist-footer-input" placeholder="Type your message..." />
        <button class="ai-assist-footer-send">
          <nb-icon icon="paper-plane-outline"></nb-icon>
        </button>
      </div>
    </footer>
  </section>
</div>